(function () {
    'use strict';

    angular.module('order')
        .controller('OperationLayoutController', OperationLayoutController);

    OperationLayoutController.$inject = ['$scope', '$state'];

    function OperationLayoutController($scope, $state) {
        var self = this;

        self.breadcrumb = [];
        self.checkActive = checkActive;

        activate();

        function activate() {}

        function checkActive(viewName) {
            return $state.includes(viewName);
        }
    }
})();
